import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M13 7h-6l4 5l-4 5h6l4 -5z","key":"svg-0"}]]

const IconArrowBadgeRight = createReactComponent('outline', 'arrow-badge-right', 'ArrowBadgeRight', __iconNode);

export default IconArrowBadgeRight;